export default {
    Metadata: {
        Name: "isDirtyProperty",
        Description: "DEPRECATED: Use isDirtyColumn()",
        Syntax: "IsDirtyProperty(<columnUID>)",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
    },
    execute(gv) {
        console.warn("DEPRECATED: isDirtyProperty will be deprecated, please use isDirtyColumn()");
        if (gv == null) {
            return false;
        }
        else {
            return gv.isDirty();
        }
    },
};

